<template>
  <i @click="$emit('input', !value)" :class="{
    'fa fa-check-square': value,
    'far fa-square': !value,
    'disabled': disabled
  }"></i>
</template>


<script>
  export default {
    props: {
      value: {
        type: Boolean,
        required: true
      },
      disabled: {
        type: Boolean,
        default: false
      }
    }
  }
</script>


<style scoped>
  i {
    font-size: 30px;
    cursor: pointer;
  }
  i.fa-check-square {
    color: green;
  }
  i:hover {

  }
  i.disabled {
    cursor: default;
    color: gray;
  }
</style>



// WEBPACK FOOTER //
// src/components/common/Tickbox.vue